import { CSSProperties } from "@material-ui/core/styles/withStyles";

// ~-~-~-~-~-~-~-~-~-~-~-
// ChromeDay
// ~-~-~-~-~-~-~-~-~-~-~-
export const mainContainer: CSSProperties = {
  position: "relative",
  display: "flex",
  flexDirection: "column",
  height: "calc(100vh - 219px)",
};

export const scrollContainer: CSSProperties = {
  flex: 1,
  position: "relative",
  paddingBottom: 102, // offset for fixed FAB
  overflow: "hidden auto",
};

export const scrollContainerBackground: CSSProperties = {
  ...scrollContainer,
  display: "flex",
  height: "calc(100vh - 219px)",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
};

export const fastCrawlHeaderContainer: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  height: "100%",
  alignItems: "center",
  justifyContent: "center",
};

export const fastCrawlHeader: CSSProperties = {
  textAlign: "center",
  margin: "0 24px",
};

// this is important since we remove the main container padding
// without this, the schedule button will hug the sides and be inconsistent
export const feedSchedulerContainer: CSSProperties = {
  paddingLeft: 10,
  paddingRight: 2,
};

export const dayBoxesAndEventsContainer: CSSProperties = {
  marginTop: 24,
  position: "relative",
  marginLeft: 50,
};
